import { render } from "./ConfirmedBackToPharmacy.vue?vue&type=template&id=556501ec"
import script from "./ConfirmedBackToPharmacy.vue?vue&type=script&lang=js"
export * from "./ConfirmedBackToPharmacy.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__